import React from 'react';
import { render } from 'react-dom';
import App from '../components/app';
import { store } from '../redux/store';
import { Provider } from 'react-redux';
import { createBrowserHistory } from 'history';
import { loadAllSettings } from 'travco-services';
import { ThemeSwitcher } from 'react-bootstrap-theme-switcher';
import { setupUserManager, userManager } from '../utils/user-manager';
import { OidcProvider } from 'redux-oidc';
import { BrowserRouter as Router } from 'react-router-dom';

const history = createBrowserHistory();

// Hook up the setupUserManager on store changes, since we need to wait for the settings
let unsubscribe = store.subscribe(function() {
    setupUserManager(store.getState().settings);
});

// Load initial state.
store.dispatch(loadAllSettings());

let themes = [ 'default', 'cerulean', 'lumen', 'simplex', 'slate', 'spacelab' ];

let renderIfReady = function() {
    // We defer rendering until the userManager is up, otherwise the OidcProvider throws a wobbler
    if (userManager) {
        unsubscribe();
        render(
            <Provider store={store}>
                <Router history={history}>
                    <ThemeSwitcher defaultTheme="default" themePath="/themes" storeThemeKey="themeSwitcher">
                        <OidcProvider store={store} userManager={userManager}>
                            <App />
                        </OidcProvider>
                    </ThemeSwitcher>
                </Router>
            </Provider>,
            document.getElementById('app')
        );
    } else {
        setTimeout(renderIfReady, 500);
    }
};

setTimeout(renderIfReady, 500);
